import { Box, Flex, Text } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";

interface Props {
  text: string;
  textSize?: string | number;
  iconStyle?: object;
  handleToggle?: () => void;
  show: boolean;
  icon?: ReactNode;
  isActive?: boolean;
  isTrunc?: boolean;
  [x: string]: any;
}

function CollapseButton({ text, textSize, handleToggle, show, icon, iconStyle, isActive, isTrunc, ...props }: Props) {
  return (
    <Flex
      align="center"
      userSelect="none"
      justify="space-between"
      color={isActive ? "blue.500" : "gray.500"}
      cursor="pointer"
      borderRightColor="blue.500"
      borderRightWidth={isActive ? "1px" : 0}
      py={3}
      maxW="150px"
      onClick={handleToggle}
      // borderWidth="1px"
      {...props}>
      <Flex w={isTrunc ? "100%" : ""}>
        {icon && (
          <Box my="auto" fontSize="xl" mr={2}>
            {icon}
          </Box>
        )}
        <Text isTruncated my="auto" fontSize={textSize} fontWeight={700}>
          {text}
        </Text>
      </Flex>
      <Box my="auto" fontSize="3xl" px={2} {...iconStyle}>
        {!show ? <HiChevronDown /> : <HiChevronUp />}
      </Box>
    </Flex>
  );
}

export default CollapseButton;
